<template>
  <div>
    <h1>{{ title }}</h1>
    <p>{{ subtitle }}</p>
  </div>
</template>

<script>
export default {
  name: "main-text-block",
  props: {
    title: {
      type: String,
      default: () => "",
    },
    subtitle: {
      type: String,
      default: () => "",
    },
  },
};
</script>

<style lang="scss" scoped>
h1 {
  font-family: "UAF Sans H", serif;
  font-size: 72px;
  text-align: center;
  height: 67px;
  text-transform: uppercase;
  white-space: nowrap;
}

p {
  font-size: 24px;
  text-align: center;
  font-family: "UAF Sans HR", serif;
}

.main-text {
  display: flex;
  flex-direction: column;
  gap: 22px;
  @media (max-width: 767px) {
    gap: 12px;
    h1 {
      font-weight: 700;
      font-size: 30px;
      line-height: 100%;
      text-align: center;
      height: unset;
    }

    p {
      font-weight: 400;
      font-size: 22px;
      line-height: 100%;
      text-align: center;
    }
  }
  @media (min-width: 768px) and (max-width: 1360px) {
    display: flex;
    flex-direction: column;
    gap: 22px;
    h1 {
      font-weight: 700;
      font-size: 60px;
      line-height: 100%;
      text-align: center;
      height: unset;
    }

    p {
      font-weight: 400;
      font-size: 24px;
      line-height: 100%;
      text-align: center;
    }
  }
}
</style>
